import { createStore } from 'vuex';

const store = createStore({
    state:{
        Token: '',
    },
    mutations:{
        setToken(state, data){
            state.Token = data;
        },
    },
    actions:{
        saveToken({commit}, data){
            commit('setToken', data);
        },
    },
    getters:{
        getToken: state => state.Token,
    }
});

export default store;